var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-bienes m-t-50"},[_c('h4',[_vm._v(" Equipos ")]),_vm._l((_vm.siniestro.bienes),function(bien){return _c('info-bien',{attrs:{"bien":bien}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }